import { render, staticRenderFns } from "./PurchaseRequestItemTable.vue?vue&type=template&id=1f4ba1c3&scoped=true&"
import script from "./PurchaseRequestItemTable.vue?vue&type=script&lang=js&"
export * from "./PurchaseRequestItemTable.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseRequestItemTable.vue?vue&type=style&index=0&id=1f4ba1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4ba1c3",
  null
  
)

export default component.exports